import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toHandlers as _toHandlers, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "cbContainer",
  class: "color-by-container"
}
const _hoisted_2 = {
  key: 0,
  style: {"padding":"16px 0px"}
}
const _hoisted_3 = { class: "color-by-select" }
const _hoisted_4 = { class: "color-by-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "color-by-row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrows-alt" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "color-by-row"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrows-alt" }, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "color-by-row"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrows-alt" }, null, -1)
const _hoisted_12 = {
  key: 3,
  class: "color-by-row"
}
const _hoisted_13 = { style: {"padding":"15px 0px"} }
const _hoisted_14 = {
  key: 0,
  ref: "SolidSelectorAnchor",
  class: "color-by-row"
}
const _hoisted_15 = {
  key: 1,
  ref: "propSelectorAnchor",
  class: "color-by-row"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-list-alt" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-palette" }, null, -1)
const _hoisted_18 = {
  key: 3,
  class: "color-table"
}
const _hoisted_19 = { class: "continuous-color-table" }
const _hoisted_20 = { style: {"display":"flex","margin-bottom":"10px","align-items":"center","gap":"10px"} }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"10pt"},
  class: "material-symbols-outlined"
}, "invert_colors", -1)
const _hoisted_22 = { style: {"display":"flex","margin-top":"25px","align-items":"center","gap":"15px"} }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "material-symbols-outlined",
  style: {"font-size":"10pt","padding":"5px"}
}, "horizontal_distribute", -1)
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 4,
  class: "discrete-color-table"
}
const _hoisted_26 = {
  key: 5,
  class: "picks-color-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_switch = _resolveComponent("imdex-switch")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_PropSelector = _resolveComponent("PropSelector")!
  const _component_ColorMapSelector = _resolveComponent("ColorMapSelector")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_IndexedColors = _resolveComponent("IndexedColors")!
  const _component_Histogram = _resolveComponent("Histogram")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_FieldRange = _resolveComponent("FieldRange")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_PicksColorPicker = _resolveComponent("PicksColorPicker")!

  return (_ctx.isReady)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.tempConfig.isGAS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_imdex_switch, {
                value: _ctx.useGASColors,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.useGASColors) = $event)),
                label: "ioGAS Colors"
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_imdex_text_field, {
              unit: "%",
              alignText: "right",
              small: "",
              type: "number",
              slider: "",
              min: 0,
              value: _ctx.layerOpacity,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.layerOpacity) = $event)),
              onMousedown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setUpdating('opacity'))),
              onMouseup: _ctx.finishedUpdating,
              max: 100
            }, null, 8, ["value", "onMouseup"])
          ]),
          (_ctx.datasetType == 'drillhole' && _ctx.tempConfig?.layerType == 'interval')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_imdex_text_field, {
                  alignText: "right",
                  small: "",
                  slider: "",
                  type: "number",
                  min: 1,
                  value: _ctx.layerLineWidth,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.layerLineWidth) = $event)),
                  onMousedown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setUpdating('lineWidth'))),
                  onMouseup: _ctx.finishedUpdating,
                  max: _ctx.maxPointSize
                }, null, 8, ["value", "onMouseup", "max"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.datasetType == 'drillhole' && _ctx.tempConfig?.layerType == 'point')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_imdex_text_field, {
                  alignText: "right",
                  small: "",
                  slider: "",
                  type: "number",
                  min: 1,
                  value: _ctx.layerPointSize,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.layerPointSize) = $event)),
                  onMousedown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setUpdating('pointSize'))),
                  onMouseup: _ctx.finishedUpdating,
                  max: _ctx.maxPointSize
                }, null, 8, ["value", "onMouseup", "max"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.datasetType == 'points')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_imdex_text_field, {
                  alignText: "right",
                  small: "",
                  slider: "",
                  type: "number",
                  min: 1,
                  onMousedown: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setUpdating('pointSize'))),
                  onMouseup: _ctx.finishedUpdating,
                  value: _ctx.layerPointSize,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.layerPointSize) = $event)),
                  max: _ctx.maxPointSize
                }, null, 8, ["onMouseup", "value", "max"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.datasetType == 'blockmodel')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("i", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleCellOutline())),
                  class: _normalizeClass([{ active: _ctx.cellOutline }, "fad fa-border-outer"])
                }, null, 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_Transition, {
            "enter-active-class": "fadeInUp",
            "leave-active-class": "fadeOutDown"
          }, {
            default: _withCtx(() => [
              (_ctx.propSelectorOpen)
                ? (_openBlock(), _createBlock(_component_PropSelector, {
                    key: 0,
                    ref: "propSelector",
                    onSelectProp: _ctx.selectProp,
                    selectedProp: _ctx.tempConfig.selectedProperty,
                    availableProps: _ctx.tempConfig.availableProperties,
                    isLoading: _ctx.isBusy || _ctx.applyingPropertySettings
                  }, null, 8, ["onSelectProp", "selectedProp", "availableProps", "isLoading"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "enter-active-class": "fadeInUp",
            "leave-active-class": "fadeOutDown"
          }, {
            default: _withCtx(() => [
              (_ctx.colorMapSelectorOpen)
                ? (_openBlock(), _createBlock(_component_ColorMapSelector, {
                    key: 0,
                    ref: "colorMapSelector",
                    tempConfig: Object.assign({ ..._ctx.tempConfig }, { preset: _ctx.preset }),
                    fileName: _ctx.fileName,
                    value: _ctx.presetName,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.presetName) = $event)),
                    categorical: _ctx.tempConfig.selectedProperty.type == 'categorical'
                  }, null, 8, ["tempConfig", "fileName", "value", "categorical"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (
					!_ctx.tempConfig.pickProperty &&
					!(_ctx.datasetType == 'surface') &&
					_ctx.tempConfig.availableProperties[0].children.length == 0
				)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_ctx.solidColorPickerOpen)
                  ? (_openBlock(), _createBlock(_component_ColorPicker, {
                      key: 0,
                      color: _ctx.activeSolidColor,
                      onChange: _ctx.pickSolidColor,
                      ref: "solidColorPicker"
                    }, null, 8, ["color", "onChange"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "color-block",
                  ref: "solidColorPickerBlock",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openSolidColorPicker())),
                  style: _normalizeStyle(`background:${_ctx.activeSolidColor}`)
                }, null, 4),
                _createVNode(_component_imdex_select, {
                  items: [{ text: _ctx.$t(`ssa.displayPane.colorBySelector.solid`), value: 'solid' }],
                  value: 'solid',
                  small: ""
                }, null, 8, ["items"])
              ], 512))
            : _createCommentVNode("", true),
          (
					!_ctx.tempConfig.pickProperty &&
					!(_ctx.datasetType == 'surface') &&
					_ctx.tempConfig.availableProperties[0].children.length > 0
				)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_imdex_select, {
                  onClick: _ctx.openPropSelector,
                  value: 
						_ctx.tempConfig.selectedProperty != null ? _ctx.tempConfig.selectedProperty.label : ''
					,
                  small: "",
                  disabled: _ctx.disableSelector
                }, null, 8, ["onClick", "value", "disabled"])
              ], 512))
            : _createCommentVNode("", true),
          (
					_ctx.tempConfig.selectedProperty &&
					_ctx.tempConfig.selectedProperty.type == 'continuous' &&
					!_ctx.tempConfig.pickProperty
				)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                ref: "colorMapSelectorAnchor",
                class: _normalizeClass(["color-by-row", { disabled: _ctx.tempConfig.selectedProperty == null }])
              }, [
                _hoisted_17,
                _createVNode(_component_imdex_select, {
                  onClick: _ctx.openColorMapSelector,
                  disabled: _ctx.disableSelector,
                  value: _ctx.presetName.text,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.presetName.text) = $event)),
                  small: ""
                }, null, 8, ["onClick", "disabled", "value"])
              ], 2))
            : _createCommentVNode("", true),
          (
					_ctx.tempConfig.selectedProperty != null && !_ctx.tempConfig.pickProperty
						? _ctx.tempConfig.selectedProperty.type == 'categorical'
						: false
				)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_IndexedColors, {
                  ref: "indexedColors",
                  isLoading: _ctx.isBusy,
                  isBlastdog: (_ctx.config as any).isBlastdog,
                  colorByFieldProp: (_ctx.tempConfig as any).selectedProperty,
                  useGASAttributesProp: _ctx.useGASColors,
                  componentLayerName: _ctx.config?.layerName
                }, null, 8, ["isLoading", "isBlastdog", "colorByFieldProp", "useGASAttributesProp", "componentLayerName"])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_19, [
            (_ctx.showHistogram && _ctx.gradient.length)
              ? (_openBlock(), _createBlock(_component_Histogram, {
                  key: 0,
                  width: _ctx.displayPaneWidth - 23,
                  dataRange: _ctx.histogramDataRange,
                  imageRange: _ctx.histogramColorRange,
                  gradient: _ctx.gradient,
                  inverted: _ctx.inverted,
                  bins: _ctx.histogramData,
                  image: _ctx.isContinuous && !_ctx.isLogarithmic ? _ctx.colorPreset.image : '',
                  yOffset: 0.05,
                  lowFill: _ctx.colorPreset.minColor,
                  highFill: _ctx.colorPreset.maxColor,
                  logScale: _ctx.useLogScale
                }, null, 8, ["width", "dataRange", "imageRange", "gradient", "inverted", "bins", "image", "yOffset", "lowFill", "highFill", "logScale"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "gradient-block-img",
                style: _normalizeStyle(`background:${_ctx.colorGradient};`)
              }, null, 4),
              (!_ctx.presetIsFixed)
                ? (_openBlock(), _createBlock(_component_imdex_btn, {
                    key: 0,
                    small: "",
                    fab: "",
                    mini: "",
                    compact: "",
                    text: "",
                    onClick: _ctx.invertPreset
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_imdex_select, {
              disabled: _ctx.presetIsFixed,
              small: "",
              value: _ctx.colorType,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.colorType) = $event)),
              items: [
						{ text: _ctx.$t(`ssa.displayPane.colorBySelector.linear`), value: 'Continuous' },
						{ text: _ctx.$t(`ssa.displayPane.colorBySelector.log`), value: 'Logarithmic' }
					]
            }, null, 8, ["disabled", "value", "items"]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _createVNode(_component_FieldRange, {
                  name: "Color By",
                  hideRange: _ctx.isCategorical,
                  layerName: _ctx.activeStore.SSA_ACTIVE_LAYER,
                  fields: _ctx.activeDataset && _ctx.activeDataset.datasetColumnMapping,
                  value: _ctx.fieldModel,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.fieldModel) = $event)),
                  isCategorical: _ctx.isCategorical,
                  "no-border": "",
                  isFixed: _ctx.presetIsFixed,
                  onChange: _ctx.colorByPush,
                  onReset: _ctx.colorByReset,
                  disabled: _ctx.disableSelector
                }, null, 8, ["hideRange", "layerName", "fields", "value", "isCategorical", "isFixed", "onChange", "onReset", "disabled"])
              ]),
              _createVNode(_component_imdex_tooltip, {
                delay: 1000,
                top: ""
              }, {
                activator: _withCtx((on) => [
                  _createVNode(_component_imdex_btn, _mergeProps({ disabled: _ctx.presetIsFixed }, _toHandlers(on), {
                    fab: "",
                    small: "",
                    mini: "",
                    compact: "",
                    onClick: _ctx.snapColorRange,
                    text: ""
                  }), {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 2
                  }, 1040, ["disabled", "onClick"])
                ]),
                tooltip: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t(`ssa.displayPane.colorBySelector.snapTo95`)
                  }, null, 8, _hoisted_24)
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, 
					_ctx.tempConfig.selectedProperty != null && !_ctx.tempConfig.pickProperty
						? _ctx.tempConfig.selectedProperty.type == 'continuous'
						: false
				]
          ]),
          false
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, null, 512)), [
                [_vShow, 
					_ctx.tempConfig.selectedProperty != null && !_ctx.tempConfig.pickProperty
						? _ctx.tempConfig.selectedProperty.type == 'continuous' && _ctx.isDiscrete
						: false
				]
              ])
            : _createCommentVNode("", true),
          (_ctx.tempConfig.pickProperty && _ctx.tempConfig.selectedProperty != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_PicksColorPicker, {
                  r: _ctx.remoteColorByState,
                  layerName: _ctx.config.layerName,
                  color: _ctx.tempConfig.color,
                  defaults_applied: _ctx.config.defaults_applied
                }, null, 8, ["r", "layerName", "color", "defaults_applied"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 512))
    : _createCommentVNode("", true)
}